// Format disconnection reason check calls_platform/app/utils/strings.tsx formatDisconnectionReason
export function formatDisconnectionReason(reason: string | null): string {
  if (!reason) return '-'
  return reason
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase())
}

export function formatDisconnectionReasonCallCard(reason: string | null | undefined) {
  if (!reason) return '-';
  return reason
    .replace(/[-_]/g, ' ')
    .replace(/\./g, '. ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}